import { SvgIcon, SvgIconProps } from '@mui/material';

const TotalIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0049 0C10.9966 0 7.22925 1.559 4.39691 4.3919C1.56335 7.22479 0 10.9926 0 15C0 19.0073 1.55949 22.7751 4.39431 25.6079C7.22538 28.4408 10.9929 30 14.9998 30C19.0094 30 22.7795 28.4395 25.613 25.6054C31.4636 19.7575 31.4611 10.2411 25.613 4.3919C22.7795 1.56027 19.0119 0 15.0049 0ZM14.9996 2.5475C18.3275 2.5475 21.4528 3.84294 23.806 6.19305C28.6616 11.0487 28.6616 18.9487 23.806 23.8043C21.4516 26.1569 18.3238 27.4523 14.9946 27.4523C11.6679 27.4523 8.5425 26.1582 6.1905 23.8068C3.83983 21.4554 2.5428 18.3271 2.5428 15C2.5428 11.6728 3.83861 8.54569 6.19312 6.19305C8.5451 3.84294 11.673 2.5475 14.9996 2.5475ZM9.98308 11.1786C9.2785 11.1786 8.70899 11.7493 8.70899 12.4524C8.70899 13.1555 9.2785 13.7262 9.98308 13.7262H20.0165C20.7211 13.7262 21.2906 13.1555 21.2906 12.4524C21.2906 11.7493 20.7211 11.1786 20.0165 11.1786H9.98308ZM9.98308 16.2737C9.2785 16.2737 8.70899 16.8443 8.70899 17.5475C8.70899 18.2506 9.2785 18.8212 9.98308 18.8212H20.0165C20.7211 18.8212 21.2906 18.2506 21.2906 17.5475C21.2906 16.8443 20.7211 16.2737 20.0165 16.2737H9.98308Z"
      fill="white"
    />
  </SvgIcon>
);

export default TotalIcon;
